import classNames from 'classnames';
import React from 'react';

import css from './IconFood.module.css';

const IconFood = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 24 24"
    >
      <path
        d="M7.5 22h10a2.5 2.5 0 0 0 2.5-2.5v-7.621a1.368 1.368 0 0 0 1-1.379 2.493 2.493 0 0 0-1.26-2.158A1.488 1.488 0 0 0 20 7.5 2.5 2.5 0 0 0 17.5 5h-10A2.5 2.5 0 0 0 5 7.5a1.488 1.488 0 0 0 .26.842A2.585 2.585 0 0 0 4 10.559a1.353 1.353 0 0 0 1 1.328V19.5A2.5 2.5 0 0 0 7.5 22Zm10-1h-10A1.5 1.5 0 0 1 6 19.5v-7.7a1.429 1.429 0 0 0 .518-.4c.364-.467.858-.619 1.688 0a2.5 2.5 0 0 0 3.268 0 1.51 1.51 0 0 1 2.066 0 2.494 2.494 0 0 0 3.265 0c.618-.463 1.2-.621 1.677-.008a1.443 1.443 0 0 0 .518.4V19.5a1.5 1.5 0 0 1-1.5 1.5ZM6 7.5A1.5 1.5 0 0 1 7.5 6h10A1.5 1.5 0 0 1 19 7.5a.5.5 0 0 1-.5.5h-12a.5.5 0 0 1-.5-.5Zm-1 3A1.5 1.5 0 0 1 6.5 9h12a1.514 1.514 0 0 1 1.5 1.552.4.4 0 0 1-.73.223c-.839-1.075-2.023-.956-3.07-.175a1.508 1.508 0 0 1-2.065 0 2.5 2.5 0 0 0-3.266 0 1.512 1.512 0 0 1-2.068 0c-1.087-.815-2.258-.866-3.077.183A.4.4 0 0 1 5 10.559Zm9.848 3.278-1.6-.923a1.51 1.51 0 0 0-1.5 0l-1.6.923a1.5 1.5 0 0 0-.75 1.3v1.846a1.5 1.5 0 0 0 .75 1.3l1.6.923a1.507 1.507 0 0 0 1.5 0l1.6-.923a1.5 1.5 0 0 0 .75-1.3v-1.847a1.5 1.5 0 0 0-.75-1.299Zm-.25 3.145a.5.5 0 0 1-.25.432l-1.6.923a.5.5 0 0 1-.5 0l-1.6-.923a.5.5 0 0 1-.25-.432v-1.846a.5.5 0 0 1 .25-.432l1.6-.923a.5.5 0 0 1 .5 0l1.6.923a.5.5 0 0 1 .25.432Z"
        fill="#011602"
      />
    </svg>
  );
};

export default IconFood;
